import React, { useState, useEffect } from 'react';
import { Spin } from '@douyinfe/semi-ui';
import { IconLoading } from '@douyinfe/semi-icons';

const Loader = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length >= 3) return '';
        return prev + '.';
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loader-container">
      <div className="loader-content">
        <Spin size="large" indicator={<img src={window.location.protocol + "//" + window.location.hostname + "/assets/logo.png"} className="loader-logo" />} />
        <span className="loader-text">Loading{dots}</span>
      </div>
    </div>
  );
};

export default Loader;

